import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import { getOptionsFromRefList } from "@/util/common_function";
import { Form } from "antd";
import { forwardRef, useEffect } from "react";
import { SCHEMA_NAME } from "@/util/common_variable";

const EmergencyForm = forwardRef(
  ({ formData, updateForm, bookingsFieldsEnabled, startingPoint = "Bookings" }, ref) => {
    const [form] = Form.useForm();

    // -----------------------------------------------------------------------
    // Sync external formData → antd form
    // -----------------------------------------------------------------------
    useEffect(() => {
      form.setFieldsValue(formData);
    }, [formData]);

    // -----------------------------------------------------------------------
    // Render
    // -----------------------------------------------------------------------
    return (
      <FieldSecurityProvider
        entity={SCHEMA_NAME.BIO}
        startingPoint={startingPoint}
        bookingsFieldsEnabled={bookingsFieldsEnabled}
      >
        <Form
          form={form}
          disabled={!bookingsFieldsEnabled}
          initialValues={formData}
          onBlur={() => updateForm(form.getFieldsValue())}
        >
          <StyledGridRow gutter={16}>

            {/* Emergency Contact */}
            <StyledGridCol span={6}>
              <SecureFormItem
                fieldName="emergencyContact"
                formItemProps={{ name: "emergencyContact", label: "Emergency Contact" }}
              >
                <TextField />
              </SecureFormItem>
            </StyledGridCol>

            {/* Relationship */}
            <StyledGridCol span={6}>
              <SecureFormItem
                fieldName="emergencyContactRelationshipId"
                formItemProps={{
                  name: "emergencyContactRelationshipId",
                  label: "Relationship",
                }}
              >
                <Select
                  options={getOptionsFromRefList(
                    "Emergency_Contact_Relationship",
                    false,
                    false,
                    true
                  )}
                  placeholder="Relationship"
                  showSearch
                  variant="outlined"
                />
              </SecureFormItem>
            </StyledGridCol>

            {/* Emergency Phone */}
            <StyledGridCol span={6}>
              <SecureFormItem
                fieldName="emergencyPhone"
                formItemProps={{ name: "emergencyPhone", label: "Emergency Phone" }}
              >
                <TextField type="number" />
              </SecureFormItem>
            </StyledGridCol>

            {/* Emergency Address */}
            <StyledGridCol span={6}>
              <SecureFormItem
                fieldName="emergencyAddress"
                formItemProps={{ name: "emergencyAddress", label: "Emergency Address" }}
              >
                <TextField />
              </SecureFormItem>
            </StyledGridCol>

            {/* Physician Name */}
            <StyledGridCol span={6}>
              <SecureFormItem
                fieldName="physicianName"
                formItemProps={{ name: "physicianName", label: "Physician Name" }}
              >
                <TextField />
              </SecureFormItem>
            </StyledGridCol>

            {/* Physician Phone */}
            <StyledGridCol span={6}>
              <SecureFormItem
                fieldName="physicianPhone"
                formItemProps={{ name: "physicianPhone", label: "Physician Phone" }}
              >
                <TextField type="number" />
              </SecureFormItem>
            </StyledGridCol>

            {/* Blood Type */}
            <StyledGridCol span={6}>
              <SecureFormItem
                fieldName="bloodType"
                formItemProps={{ name: "bloodType", label: "Blood Type" }}
              >
                <Select
                  options={getOptionsFromRefList("BloodType")}
                  placeholder="Blood Type"
                  showSearch={false}
                  variant="outlined"
                />
              </SecureFormItem>
            </StyledGridCol>

          </StyledGridRow>
        </Form>
      </FieldSecurityProvider>
    );
  }
);

export default EmergencyForm;